import type { Note, Person } from "@/services/api";

export const getTableCardMobileContent = ({ note, person }: { note?: Note; person?: Person }) => {
  return {
    date: note?.noteDate ?? "",
    dueDate: note?.dueDate?.length ? (note?.dueDate ?? "") : "",
    person: person ?? null,
    cardTitle: note?.title ?? "",
    note: note?.text ?? "",
    flag: note?.direction ?? "INCOMING",
    id: note?.id ?? "",
  };
};
